module.exports = __webpack_public_path__ + "static/media/07 REGGIANA CALCIO Panizzi.0e892d61.svg";